import React from 'react';
import { Button, Badge } from '@chakra-ui/react';
import * as FiIcons from 'react-icons/fi';
import Table from '../../../shared/table/Table';

const ContentCreatorsTable = ({ data, page, handleUpdate, handleDelete }) => (
  <Table>
    <thead>
      <tr>
        <th>#</th>
        <th>الاسم</th>
        <th>التاق</th>
        <th>المنصة الرئيسية</th>
        <th>المتابعون</th>
        <th>الفيديوهات</th>
        <th>التوثيق</th>
        <th>إجراءات</th>
      </tr>
    </thead>
    <tbody>
      {data?.map((creator, idx) => (
        <tr key={creator._id}>
          <td>{(page - 1) * 10 + idx + 1}</td>
          <td>{creator.name}</td>
          <td>{creator.tag}</td>
          <td>{creator.primary_platform}</td>
          <td>{creator.followers}</td>
          <td>{creator.videos_count}</td>
          <td>
            {creator.is_verified
              ? <Badge colorScheme="green">موثقة</Badge>
              : <Badge colorScheme="gray">غير موثقة</Badge>}
          </td>
          <td>
            <Button bg="transparent" color="green" size="xs" onClick={() => handleUpdate(creator)}>
              <FiIcons.FiEdit size={20} />
            </Button>
            <Button bg="transparent" color="red.600" size="xs" onClick={() => handleDelete(creator)}>
              <FiIcons.FiDelete size={20} />
            </Button>
          </td>
        </tr>
      ))}
    </tbody>
  </Table>
);

export default ContentCreatorsTable;
